import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Building, ChevronDown, Icon } from 'pi-kiosk-shared/ui/Icon';
import { persistCheckoutLeaveOffQrFromSearch } from '../features/checkout/checkoutInFlowStepStorage.js';
import { PLATFORM_ORGS_PATH } from '../features/shop/resolveShopHref.js';
import { CUSTOMER_SHELL_ORG_CONTROL_CLASS } from './customerTopBarStyles.js';

export interface CustomerOrganizationControlProps {
  readonly className?: string;
}

/**
 * Retail V1 shell org chrome — Building + label + chevron → platform `/orgs`.
 */
export function CustomerOrganizationControl({
  className,
}: CustomerOrganizationControlProps): JSX.Element {
  const { t } = useTranslation('customer');
  const { search } = useLocation();
  const label = t('chrome.organization.label', { defaultValue: t('nav.orgs') });
  const openAria = t('chrome.organization.openAria', { defaultValue: label });

  return (
    <Link
      to={PLATFORM_ORGS_PATH}
      className={[CUSTOMER_SHELL_ORG_CONTROL_CLASS, className].filter(Boolean).join(' ')}
      aria-label={openAria}
      title={label}
      data-testid="customer-shell-organization"
      onClick={() => {
        persistCheckoutLeaveOffQrFromSearch(search);
      }}
    >
      <Icon icon={Building} size={20} aria-hidden={true} className="shrink-0" />
      <span className="hidden min-w-0 truncate sm:inline">{label}</span>
      <Icon icon={ChevronDown} size={16} aria-hidden={true} className="shrink-0 opacity-70" />
    </Link>
  );
}
